<style>
    .dg-btn--cancel{
        color: #fff;
        background-color: #f5365c;
        border-color: #f5365c;
    }
    .dg-btn--ok{
        color: #fff;
        background-color: #2dce89;
        border-color: #2dce89;
    }
</style>
<script>
  
    import Vue from 'vue';
    import VuejsDialog from 'vuejs-dialog';
    import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components
    
    // include the default style
    import 'vuejs-dialog/dist/vuejs-dialog.min.css';
    
    // Tell Vue to install the plugin.
    Vue.use(VuejsDialog);

  export default{
      showConfirm(text, context, callback){
            context.$dialog
        .confirm(text, {okText : 'Aceptar', cancelText: 'Cancelar'})
        .then(function(dialog) {
            callback();
        })
        // .catch(function() {
        //     console.log('Clicked on cancel');
        // });
      }
  }
</script>